<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      lineChannelId: '',
      lineChannelSecret: '',
      lineChannelToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    lineChannelId: { required },
    lineChannelSecret: { required },
    lineChannelToken: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const lineChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'line',
              line_channel_id: this.lineChannelId,
              line_channel_secret: this.lineChannelSecret,
              line_channel_token: this.lineChannelToken,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: lineChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.LINE_CHANNEL.API.ERROR_MESSAGE'), {type: 'error'});
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full flex flex-col gap-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.LINE_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.LINE_CHANNEL.DESC')"
    />
    <form class="flex w-full flex-col" @submit.prevent="createChannel()">
      <!-- Layout 2 cột -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Cột trái: Thông tin cơ bản -->
        <div class="space-y-4">
          <!-- Channel Name -->
          <div>
            <label :class="{ error: v$.channelName.$error }">
              {{ $t('INBOX_MGMT.ADD.LINE_CHANNEL.CHANNEL_NAME.LABEL') }}
              <input
                v-model="channelName"
                type="text"
                :placeholder="
                  $t('INBOX_MGMT.ADD.LINE_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
                "
                @blur="v$.channelName.$touch"
              />
              <span v-if="v$.channelName.$error" class="message">{{
                $t('INBOX_MGMT.ADD.LINE_CHANNEL.CHANNEL_NAME.ERROR')
              }}</span>
            </label>
          </div>

          <!-- Line Channel ID -->
          <div>
            <label :class="{ error: v$.lineChannelId.$error }">
              {{ $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_ID.LABEL') }}
              <input
                v-model="lineChannelId"
                type="text"
                :placeholder="
                  $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_ID.PLACEHOLDER')
                "
                @blur="v$.lineChannelId.$touch"
              />
              <span v-if="v$.lineChannelId.$error" class="message">{{
                $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_ID.ERROR')
              }}</span>
            </label>
          </div>
        </div>

        <!-- Cột phải: Thông tin kỹ thuật -->
        <div class="space-y-4">
          <!-- Line Channel Secret -->
          <div>
            <label :class="{ error: v$.lineChannelSecret.$error }">
              {{ $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_SECRET.LABEL') }}
              <input
                v-model="lineChannelSecret"
                type="text"
                :placeholder="
                  $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_SECRET.PLACEHOLDER')
                "
                @blur="v$.lineChannelSecret.$touch"
              />
              <span v-if="v$.lineChannelSecret.$error" class="message">{{
                $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_SECRET.ERROR')
              }}</span>
            </label>
          </div>

          <!-- Line Channel Token -->
          <div>
            <label :class="{ error: v$.lineChannelToken.$error }">
              {{ $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_TOKEN.LABEL') }}
              <input
                v-model="lineChannelToken"
                type="text"
                :placeholder="
                  $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_TOKEN.PLACEHOLDER')
                "
                @blur="v$.lineChannelToken.$touch"
              />
              <span v-if="v$.lineChannelToken.$error" class="message">{{
                $t('INBOX_MGMT.ADD.LINE_CHANNEL.LINE_CHANNEL_TOKEN.ERROR')
              }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="w-full flex justify-center mt-12">
        <woot-submit-button
          class="!bg-n-bluegray-4 !text-white rounded-lg"
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.LINE_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}
</style>